import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import type { BlacklistSummaryType } from 'features/Location/@types/BlacklistArea'
import type { BlackListDetailType } from 'features/Location/@types/BlacklistAreaAddEdit'

const { Get, Post, Delete, Put } = axiosInstanceApiGateway

export type GetBlacklistAreasRequestType = {
  params: { limit: number; page: number; location_name: string }
}

export type GetBlacklistAreasResponseType = {
  blacklist_address_summary: BlacklistSummaryType[]
}

export const getBlacklistAreas = ({ params }: GetBlacklistAreasRequestType) =>
  Get<GetBlacklistAreasResponseType>({
    url: `/location/internal/v2/blacklist-address-summary`,
    params,
  })

export type GetBlacklistAreaDetailRequestType = {
  location_id: string
}

export type GetBlacklistAreaDetailResponseType = BlackListDetailType[]

export const getBlacklistAreaDetail = ({ location_id }: GetBlacklistAreaDetailRequestType) =>
  Get<GetBlacklistAreaDetailResponseType>({
    url: `/location/internal/v2/blacklist-address/${location_id}/detail`,
  })

export type PostCreateBlacklistAddressBulkRequestType = {
  blacklist_address: {
    location: {
      id: number
      name: string
      type: string
    }
    address: string
    type: number
    duration_type: string
    is_active: boolean
    start_date: string
    end_date: string
    file: string
  }[]
}

export type PostCreateBlacklistAddressBulkResponseType = {
  message: string
}

export const postCreateBlacklistAddressBulk = ({
  blacklist_address,
}: PostCreateBlacklistAddressBulkRequestType) =>
  Post<PostCreateBlacklistAddressBulkResponseType>({
    url: `/location/internal/v2/blacklist-address-bulk`,
    data: { blacklist_address },
  })

export type DeleteBlacklistAddressRequestType = {
  id: string
}
export type DeleteBlacklistAddressResponseType = {
  message: string
}

export const deleteBlacklistAddress = ({ id }: DeleteBlacklistAddressRequestType) =>
  Delete<DeleteBlacklistAddressResponseType>({
    url: `/location/internal/v2/blacklist-address/${id}`,
  })

export type PutBlacklistAddressRequestType = {
  id: string
  data: {
    location: {
      id: number
      name: string
      type: string
    }
    address: string
    type: number
    duration_type: string
    start_date: string
    end_date: string
    is_active: boolean
    file: string
  }
}

export const putBlacklistAddress = ({ id, data }: PutBlacklistAddressRequestType) =>
  Put<DeleteBlacklistAddressResponseType>({
    url: `/location/internal/v2/blacklist-address/${id}`,
    data,
  })

export type DeleteBlacklistAddressByLocationIDRequestType = {
  id: string
}

export type DeleteBlacklistAddressByLocationIDResponseType = {
  message: string
}

export const deleteBlacklistAddressByLocationID = ({
  id,
}: DeleteBlacklistAddressByLocationIDRequestType) =>
  Delete<DeleteBlacklistAddressByLocationIDResponseType>({
    url: `/location/internal/v2/blacklist-address/${id}/detail`,
  })

export type PostBulkUploadCSVBlacklistAreaRequestType = { data: FormData }
export type PostBulkUploadCSVBlacklistAreaResponseType = {
  failed_data: number
  status: string
  success_data: number
  total_data: number
}

export const postBulkUploadCSVBlacklistArea = ({
  data,
}: PostBulkUploadCSVBlacklistAreaRequestType) =>
  Post<PostBulkUploadCSVBlacklistAreaResponseType>({
    url: `/location/internal/v2/blacklist-address/bulk-upload`,
    data,
    config: {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'multipart/form-data',
      },
    },
  })

export const postBulkUploadIsochroneBlacklistArea = ({
  data,
}: PostBulkUploadCSVBlacklistAreaRequestType) =>
  Post<PostBulkUploadCSVBlacklistAreaResponseType>({
    url: `/location/internal/v1/isochrone/blacklist-address/bulk-upload`,
    data,
    config: {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'multipart/form-data',
      },
    },
  })

export type TemplateType =
  | 'template-create-blacklist-isochrone'
  | 'template-update-blacklist-isochrone'
  | 'template-upload-blacklist-address'
  | 'template-upload-blacklist-isochrone'

export type GetBlacklistTemplateRequestType = {
  type: TemplateType
}

export type GetBlacklistTemplateResponseType = {
  filename: string
  file_byte: string
}

export const getBlacklistTemplate = ({ type }: GetBlacklistTemplateRequestType) =>
  Get<GetBlacklistTemplateResponseType>({
    url: `/location/internal/v2/blacklist-address/download-template/${type}`,
  })

export type UpdateBlacklistAddressType = {
  id: string
  location: {
    id: number
    name: string
    type: string
  }
  address: string
  file: string
  type: number
  duration_type: string
  start_date: string
  end_date: string
  is_active: boolean
}

export type PutUpdateBlacklistAddressBulkRequestType = {
  payload: {
    blacklist_address: UpdateBlacklistAddressType[]
  }
  locationId: string
}

export const putUpdateBlacklistAddressBulk = ({
  payload,
  locationId,
}: PutUpdateBlacklistAddressBulkRequestType) =>
  Put<{
    message: string
  }>({
    url: `/location/internal/v2/blacklist-address/${locationId}/detail`,
    data: payload,
  })
